<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  count: { type: Number, default: 0 },
});

const { t } = useI18n();

const tooltipContent = computed(() =>
  t('CHAT_LIST.SCHEDULED_MESSAGE_TOOLTIP', { count: props.count })
);
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Icon
    v-if="count > 0"
    v-tooltip.top="{
      content: tooltipContent,
      delay: { show: 500, hide: 0 },
    }"
    icon="i-ph-clock-countdown-fill"
    class="size-4 text-n-blue-11 flex-shrink-0"
  />
</template>
